export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/KZ-65fa38e06b5d23349e87db63363bfbb2.png";